import Swal from "sweetalert2";

export const AlertDescription = (title, descrip, icon) => {
    return Swal.fire(title, descrip, icon);
};
